module.exports = __webpack_public_path__ + "static/7-075bb61764a3b80e378a27296f7f5ba0.svg";